export default __webpack_public_path__ + "static/0009-3ad498f774b16471780f74f9ef1a2452.png";